export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          有任何问题或建议？欢迎与天天影院团队取得联系
        </p>

        <div className="bg-background-50 border border-background-200/60 rounded-xl p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-primary-500/10 flex items-center justify-center mb-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@tiantiancinema.com</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-accent-500/10 flex items-center justify-center mb-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-accent-500 text-lg"></i>
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">用户反馈</h3>
              <p className="text-xs text-foreground-500">feedback@tiantiancinema.com</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-secondary-500/10 flex items-center justify-center mb-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-film-line text-secondary-500 text-lg"></i>
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">content@tiantiancinema.com</p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/40 text-center">
            <p className="text-xs text-foreground-500 mb-3">
              或通过以下渠道关注天天影院的每日更新
            </p>
            <div className="flex items-center justify-center gap-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 text-foreground-500 hover:text-primary-500 hover:border-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 text-foreground-500 hover:text-primary-500 hover:border-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 text-foreground-500 hover:text-primary-500 hover:border-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 border border-background-200/60 text-foreground-500 hover:text-primary-500 hover:border-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-live-line"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}